import { useNavigate } from 'react-router-dom';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { logout } from '../../store/slices/usuario';
import { CursoState, setCurso } from '../../store/slices/curso';
import { obtenerModulosCurso, startLoadingModulo } from '../../store/slices/modulo';
// mui components
import { AppBar, Button, Toolbar, Typography } from '@mui/material'
// mui icons
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
// componentes propios
import {useEffect} from 'react';
import Latex from 'react-latex-next';

const drawerWidth = 0;

const Inicio = () => {

    const dispatch = useDispatch<AppDispatch>();

    const { cursos } = useSelector((state: RootState) => state.curso);

    const navigate = useNavigate();

    const handleLogout = () => {
        // console.log('Logout');
        dispatch(logout())
    }

    const handleCurso = (curso: CursoState) => {

        const { cid, sigla } = curso; 

        if (cid && sigla) {
            const { cid, sigla } = curso; 
            dispatch(startLoadingModulo());
            dispatch(obtenerModulosCurso(cid));
            navigate(`/curso/${sigla}/${0}`);
            dispatch(setCurso(curso));
        }
    }

    useEffect(() => {
      dispatch(setCurso({cid: '', sigla: '', nombre: '', descripcion: ''}))
    }, [dispatch])
    

    return (
        <div className="portada">
            <AppBar
                position="fixed"
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                }}
                style={{
                    boxShadow: "0px 0px 0px 0 rgba(0, 0, 0, 0)", 
                    background: 'transparent',
                    color: 'white'
                }}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        // onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap component="div">
                        {/* MATUC */}
                    </Typography>

                    <IconButton
                        // color="primary"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleLogout}
                        style={{position: 'absolute', right: "20px", color: 'white'}}
                    >
                        <LogoutIcon />
                    </IconButton>
                    
                </Toolbar>

            </AppBar>

            <Toolbar />
            
            <div className="container">

                <h1 style={{color: 'white'}}>Cursos</h1>

                <div className="row gx-5 my-5">
                    {
                        cursos.map(curso => {
                            const { cid, sigla, nombre, descripcion } = curso;
                            return (
                                <div className="col-lg-6 col-xl-4" key={cid}>
                                    <div 
                                        className="card mb-5" 
                                        style={{
                                            width: '300px', 
                                            minHeight: '250px',
                                            boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.3)',
                                        }}
                                        
                                    >
                                        <div className="card-header" style={{background: 'transparent', borderBottom: 'none', borderTop: 'solid 4px #183e8a'}}>
                                            <span style={{fontSize: '1.3em'}}>{sigla} - {nombre}</span>
                                        </div>
                                        <div className="card-body" style={{textAlign: 'justify'}}>
                                            <Latex>{descripcion}</Latex>
                                        </div>
                                        <div className="card-footer" style={{background: 'transparent', borderTop: 'none'}}>
                                            <Button
                                                className='float-end'
                                                variant="contained"
                                                color='info'
                                                onClick={() => handleCurso(curso)}
                                            >
                                                Ingresar
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            ) 
                        })
                    }                    
                </div>
            </div>
        </div>
    )
}

export default Inicio;